// extracted by mini-css-extract-plugin
module.exports = {"canvas":"styles_canvas__1mpzu","hidden":"styles_hidden__1FN8-"};